/**
 * @generated SignedSource<<812dca6916c7e15d7110b0ff4df70aaf>>
 * @relayHash a9628295d14ae63297d65e4283b514e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d207914af643114ac86ff641fb2c213b61c2813d287dcd93bdcf4e71a47bc2cb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d207914af643114ac86ff641fb2c213b61c2813d287dcd93bdcf4e71a47bc2cb",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
